var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3416",
    "data-name": "Group 3416",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 62.5,
    height: 62.5,
    rx: 4.75,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "style_linear",
    "data-name": "style=linear",
    transform: "translate(14 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M28.558,33.6H10.853C5.541,33.6,2,30.943,2,24.747V12.353C2,6.156,5.541,3.5,10.853,3.5H28.558c5.312,0,8.853,2.656,8.853,8.853V24.747C37.411,30.943,33.87,33.6,28.558,33.6Z",
    transform: "translate(-2 -3.5)",
    fill: "none",
    stroke: "#0ab8e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M29.2,7.769l-9.821,7.589a3.541,3.541,0,0,1-4.33,0L5.23,7.769",
    transform: "translate(0.489 -0.211)",
    fill: "none",
    stroke: "#0ab8e5",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.89aebe53e269578bb674dfad2c90350e.svg";
export { ForwardRef as ReactComponent };